import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Avtor from '@/components/screens/avtor/Avtor';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import { ISearchAuthor } from '@/interfaces/authorsPage.interface';

interface IAvtorLetterDynamic {
  data: ISearchAuthor;
}

const AvtorLetterDynamic: NextPage<IAvtorLetterDynamic> = ({ data }) => {
  return <Avtor letterData={data} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { letterSign } = context.query;

  const res = await fetch(`${API_URL}satellite/authors/serch-by-first-word/${letterSign}?page=1&page_size=${BOOKS_FOR_PAGE}`);
  const data = await res.json();

  return {
    props: {
      data,
    },
  };
};

export default AvtorLetterDynamic;
